/**
 * `visualGameAdmin.llm.*` 的文案聚合。
 *
 * 每个后续切片新建自己的一个文件(`models.js` / `modes.js` / `calls.js` / `cost.js` /
 * `runtime.js` / `recon.js`),各导出 `{ en, zh }`,然后在下面各加一行命名空间。
 *
 * `en` 与 `zh` 的 key 集必须逐字相同 —— `test/i18n.test.js` 会拍平后逐项比对。
 */

import { en as callsEn, zh as callsZh } from './calls.js'
import { en as capabilitiesEn, zh as capabilitiesZh } from './capabilities.js'
import { en as costEn, zh as costZh } from './cost.js'
import { en as conversationsEn, zh as conversationsZh } from './conversations.js'
import { en as h3ConfigEn, zh as h3ConfigZh } from './h3-config.js'
import { en as ledgerEn, zh as ledgerZh } from './ledger.js'
import { en as modelsEn, zh as modelsZh } from './models.js'
import { en as modesEn, zh as modesZh } from './modes.js'
import { en as providersEn, zh as providersZh } from './providers.js'
import { en as reconEn, zh as reconZh } from './recon.js'
import { en as runVideoMatchEn, zh as runVideoMatchZh } from './run-video-match.js'
import { en as runtimeEn, zh as runtimeZh } from './runtime.js'
import { en as sectionEn, zh as sectionZh } from './section.js'
import { en as turnTimelinesEn, zh as turnTimelinesZh } from './turn-timelines.js'

const { videoMatch: videoMatchEn, ...conversationEn } = conversationsEn
const { videoMatch: videoMatchZh, ...conversationZh } = conversationsZh

export const llmEn = {
  ...sectionEn,
  providers: providersEn,
  capabilities: capabilitiesEn,
  h3Config: h3ConfigEn,
  models: modelsEn,
  modes: modesEn,
  runtime: runtimeEn,
  recon: reconEn,
  cost: costEn,
  calls: callsEn,
  conversations: conversationEn,
  videoMatch: videoMatchEn,
  runVideoMatch: runVideoMatchEn,
  turnTimelines: turnTimelinesEn,
  ledger: ledgerEn,
}

export const llmZh = {
  ...sectionZh,
  providers: providersZh,
  capabilities: capabilitiesZh,
  h3Config: h3ConfigZh,
  models: modelsZh,
  modes: modesZh,
  runtime: runtimeZh,
  recon: reconZh,
  cost: costZh,
  calls: callsZh,
  conversations: conversationZh,
  videoMatch: videoMatchZh,
  runVideoMatch: runVideoMatchZh,
  turnTimelines: turnTimelinesZh,
  ledger: ledgerZh,
}
